import { Col, Row, Image, Menu, Collapse } from 'antd';
import { PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import Link from 'next/link';
import { useRouter } from "next/router";
import { useState, useEffect, useMemo, useRef } from 'react';
import { useSession, signIn, signOut } from "next-auth/react";
import UserProfileModal from "../pages/components/UserProfileModal"
import Avatar from "react-avatar";
import Modal from 'react-modal';
import styles from '../styles/UserProfile.module.css'
import { useTheme } from "next-themes";

export default function Sidebar({ sideMenuArrProp }) {
  const router = useRouter();
  const [selectedPath, setSelectedPath] = useState(0);
  let selectedIndexValue = 0;
  const { data: session, status } = useSession();
  const [sideMenuArr, setSideMenuArr] = useState(() => sideMenuArrProp ?? []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalHelp, setIsModalHelp] = useState(false);
  const { theme, setTheme } = useTheme();
  const [fctLogo, setFctLogo] = useState('/images/fctlogo1.png');
  // const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const mediaQueryRef = useRef(null);
  const { Panel } = Collapse;
  const { groupedMenu, ungroupedMenu } = useMemo(() => {
    const grouped = {};
    const ungrouped = [];

    sideMenuArr.forEach(item => {
      if (item.Group) {
        if (!grouped[item.Group]) grouped[item.Group] = [];
        grouped[item.Group].push(item);
      } else {
        ungrouped.push(item);
      }
    });

    return { groupedMenu: grouped, ungroupedMenu: ungrouped };
  }, [sideMenuArr]);
  useEffect(() => {
    let isMounted = true;

    mediaQueryRef.current = window.matchMedia('(prefers-color-scheme: dark)');
    const prefersDarkMode = mediaQueryRef.current.matches;

    if (isMounted) {
      if (theme === 'dark' || prefersDarkMode) {
        setFctLogo('/images/fctlogo1.png')
      }
      else {
        setFctLogo('/images/fc-logo-dark.png')
      }
    }
    return () => {
      isMounted = false;
      mediaQueryRef.current = null;
    };
  }, [theme])

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const openHelpModal = () => {
    setIsModalHelp(true);

  };
  const closeHelpModal = () => {
    setIsModalHelp(false);
  };
  const userNameStyle = {
    color: 'white',
    fontWeight: 'bold'
  };

  const selected = {
    color: '#22b27e'
  }

  const unSelected = {
    color: 'white'
  }

  useEffect(() => {
    // Skip session check if we're in candidate context (has candidateId in localStorage)
    const candidateId = localStorage.getItem('candidateId');
    const userRole = localStorage.getItem('roles');

    // Allow access if candidate is logged in OR if regular session exists
    if (!candidateId && !session && userRole !== 'Candidate') {
      // Only redirect if we're not loading and definitely not authenticated
      if (status !== 'loading') {
        router.push("/");
      }
    }
  }, [session, status, router]);

  const userRole = session?.user?.roles[0];



  //let sideMenuArr = [];

  // useEffect(() => {
  //   if (sideMenuArr && sideMenuArr.length > 0) {
  //     sideMenuArr.forEach((item) => {
  //       if (item["URL"]) {
  //         router.prefetch(item["URL"]);
  //       }
  //     });
  //   }
  // }, [sideMenuArr]);
  useEffect(() => {
    let isMounted = true;
    if (localStorage.getItem('menubardata') && sideMenuArr.length <= 0) {
      const menuObj = localStorage.getItem('menubardata');
      if (isMounted && menuObj) {
        try {
          const menuBar = JSON.parse(menuObj);
          if (menuBar?.dashboard?.[1]?.sideMenu) {
            setSideMenuArr(menuBar?.dashboard?.[1]?.sideMenu || []);
          }
        } catch (err) {
          console.error('Failed to parse menubardata:', err);
        }
      }
    }
    return () => {
      isMounted = false;
    };
  }, [sideMenuArr.length]);



  let role = session?.user?.roles[0];
  const renderMenuItem = (item, index) => {
    const isActive = router.pathname === item.URL;
    const linkStyle = isActive ? selected : unSelected;

    return (
      <li key={index} className={isActive ? 'active' : ''}>
        <Link legacyBehavior href={item.URL}>
          <a style={linkStyle}>
            <Image src={item.path} className="img-active" preview={false} />
            <Image src={item.path} className="img-default" preview={false} />
            <span>{item.Name}</span>
          </a>
        </Link>
      </li>
    );
  };

  return (
    <>
      <div className="main-sidebar">
        <Row align='middle' justify='space-between' className='sidebar-logo'>
          <Col>
            {/* <Image src="/images/logo.svg" alt="Logo" height={39} width={139} preview={false} /> */}
            <Image
              // src={fctLogo} 
              src='/images/fctlogo1.png'
              // src='/images/one_logo_white_blue.png'
              // className={styles.fctLogo}
              alt="Logo" height={45} preview={false} />
          </Col>
        </Row>
        {/* <ul className="sidebar-list">
          {
            sideMenuArr && sideMenuArr.map((item, index) => (

              <li key={index} className={router.pathname === item["URL"] ? "active" : ""}>
                {
                  role === "External User" ?
                    <Link legacyBehavior href={item["URL"]} >
                      <a
                        style={
                          router.pathname === item["URL"] ? selected : unSelected
                        }
                      >
                        <Image src={item.path} className="img-active" preview={false} />
                        <Image src={item.path} className="img-default" preview={false} />
                        <span>{item.Name}</span>
                      </a>
                    </Link> :
                    <Link legacyBehavior href={item["URL"]}>
                      <a
                        style={
                          router.pathname === item["URL"] ? selected : unSelected
                        }
                      >
                        <Image src={item.path} className="img-active" preview={false} />
                        <Image src={item.path} className="img-default" preview={false} />
                        <span>{item.Name}</span>
                      </a>
                    </Link>
                }
              </li>
            ))
          }
        </ul> */}
        <div className="sidebar-list">
          <Collapse accordion bordered={false} expandIcon={({ isActive }) =>
            isActive ? <MinusCircleOutlined /> : <PlusCircleOutlined />
          }>
            {Object.entries(groupedMenu).map(([groupName, items]) => {
              const isGroupActive = items.some(item => router.pathname === item.URL);
              return (
                <Panel header={groupName} className={isGroupActive ? 'active-group' : ''} key={groupName}>
                  <ul className="sidebar-list">
                    {items.map(renderMenuItem)}
                  </ul>
                </Panel>
              );
            })}
          </Collapse>
          <ul className="sidebar-list">
            {ungroupedMenu.map(renderMenuItem)}
          </ul>
        </div>

        <div className='sidebarBottom'>


          <Row>
            <Col span={24}>
              <ul className="sidebar-list pb-10">
                <>
                  {/* <Avatar
                    // name={session ? session.user.name : ""}
                    name='?'
                    size="30"
                    onClick={openHelpModal}
                    title='Help'
                    round={true}
                    color=" rgb(12, 63, 107"
                    className='userProfile'
                  />
                  <span style={userNameStyle}>Help</span> */}

                  {
                    isModalHelp &&
                    <Modal
                      isOpen={isModalHelp}
                      // open={isModalHelp} 
                      // closable={closeHelpModal} 
                      // afterClose={closeHelpModal}
                      onRequestClose={closeHelpModal}
                      contentLabel="Application Version"
                      style={{
                        overlay: {
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        }
                      }}
                      className={styles.userProfileModalPopup}
                    >
                      <div className={styles.modalHeader}>
                        <button className={styles.onRequestClose} onClick={closeHelpModal}>
                          <span>&times;</span>
                        </button>
                      </div>

                      <div className={styles.modalContent}>
                        <h3 >Application Version</h3>
                        <p style={{ textAlign: 'center' }} className={styles.modelLabelValue}>EDX Version 2410</p>
                        {/* <p className={styles.bottomSpace}><strong className={styles.modelLabelTitle}>Name:</strong> <span className={styles.modelLabelValue}>Shree</span></p> */}
                        <div className={styles.PopUpLogo}>
                          <Image src={fctLogo} alt="Logo" height={28} preview={false} />
                        </div>
                      </div>
                    </Modal>
                  }
                </>
              </ul>
            </Col>
            <br />
            <br />
            <Col span={24}>
              <ul className="sidebar-list pb-10">
                <>
                  <Avatar
                    // name={session ? session.user.name : ""}
                    name={localStorage.name ? localStorage.name : ""}

                    size="30"
                    onClick={openModal}
                    round={true}
                    color=" rgb(12, 63, 107"
                    className='userProfile'
                  />
                  {/* <span style={userNameStyle}>{session ? session.user.name : ""}</span> */}
                  <span style={userNameStyle}>{localStorage.name ? localStorage.name : ""}</span>
                  <UserProfileModal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                  />
                </>
              </ul>
            </Col>
          </Row>
        </div>
      </div>
    </>
  )
}